import React, {useState,useEffect} from 'react'
import styled from 'styled-components';
import BaseBtn from '../common/styled/BaseBtn'
import HuntersData from './HuntersData'
import SupportHunterModel from './SupportHunterModel'
import ConfirmSupportHunterModel from './ConfirmSupportHunterModel'
import SuccessModel from '../model/SuccessModel'
import {useNumberListVotes} from "../../hooks"

const HuntersStyle = styled.div`
  margin: 40px 0 0;
  .title-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    >h2 {
      color: #2B2F37;
      width: 66%;
    }
  }
  .hunter-list {
    margin-top: 30px;
    display: flex;
    flex-wrap: wrap;
  }
  @media (max-width: 768px) {
    .title-box {
      >h2 {
        width: 100%;
      }
    }
  }
`;

const HunterItem = styled.li`
  background: #FFFFFF;
  box-shadow: 8px 8px 23px -4px rgba(13, 64, 152, 0.16);
  border-radius: 16px;
  width: calc(33.3% - 20px);
  padding: 20px;
  padding-bottom: 150px;
  position: relative;
  margin-bottom: 20px;
  margin-right: 20px;
  &:hover {
    box-shadow: 8px 8px 23px -4px rgba(13, 64, 152, 0.26);
  }
  >h3 {
    color: #3D6DE5;
  }
  .userinfo {
    margin: 20px 0;
    display: flex;
    align-items: center;
    >.avatar {
      width: 60px;
      height: 60px;
      background-color: #ccc;
      margin-right: 10px;
      border-radius: 50%;
      >img {
        width: 100%;
        height: 100%;
      }
    }
    >h3 {
      color: #333333;
    }
  }
  .desc {
    color: #7D8A96;
    font-size: 18px;
    line-height: 30px;
    margin-bottom: 30px;
  }
  .btn-box {
    position: absolute;
    bottom: 20px;
    left: 20px;
    right: 20px;
    >.votes {
      color: #444;
      font-size: 18px;
    }
    >* {
      margin: 10px 0;
      display: block;
      &:last-child {
        background: linear-gradient(270deg, #FFB247 0%, #E74988 100%);
        &:hover {
          background: linear-gradient(270deg, #ee9922 0%, #E74988 100%);
        }
      }
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    margin-right: 0;
  }
`;

export default function Hunters() {
  const [currentHunter, setCurrentHunter] = useState({})
  const [hunterLists, sethunterLists] = useState(HuntersData)
  // const listVotes = useNumberListVotes()

  // useEffect(() => {
  //   const ret = hunterLists.map(v=> {
  //     v.votes = (listVotes && listVotes[v.address]) ?? ''
  //     return v;
  //   })
  //   sethunterLists(ret);

  // }, [listVotes])

  const [showSupportHunterModel, setShowSupportHunterModel] = useState(false)
  const toggleShowSupportHunterModel = () => {
    setShowSupportHunterModel(!showSupportHunterModel)
  }

  // set current hunter
  const ToShowSupportHunterModel = hunter => {
    setCurrentHunter(hunter);
    setShowSupportHunterModel(true)
  }
  
  const [showMeta, setshowMeta] = useState(false)

  const [ confirmSupportHunterModel, setConfirmSupportHunterModel] = useState(false)
  const toggleConfirmSupportHunterModel = () => {
    if (!window.ethereum) {
      setshowMeta(true)
    } else {
      setConfirmSupportHunterModel(!confirmSupportHunterModel)
    }
  }

  const [commitSuccess, setcommitSuccess] = useState(false)
  const toggleCommitSuccess = () => {
    setConfirmSupportHunterModel(false);
    if (commitSuccess === true) {
      setTimeout(setCurrentHunter({}))
    }
    setcommitSuccess(!commitSuccess)
  }

  return (
    <HuntersStyle>
      <SuccessModel
        show={showMeta}
        onHide={()=>{
          setshowMeta(false)
        }}
      >Please install a Metamask extension on the browser(PC) and link it first.</SuccessModel>
      
      <SuccessModel
        show={commitSuccess}
        onHide={toggleCommitSuccess}
      >To support hunter({currentHunter.name}) commit success</SuccessModel>

      <ConfirmSupportHunterModel
        show={confirmSupportHunterModel}
        onHide={toggleConfirmSupportHunterModel}
        currentHunter={currentHunter}
        onSuccess={toggleCommitSuccess}
      >
        You are about to support this hunter ({currentHunter.name})
      </ConfirmSupportHunterModel>
      <SupportHunterModel
        show={showSupportHunterModel}
        onHide={toggleShowSupportHunterModel}
        toSupport={toggleConfirmSupportHunterModel}
      ></SupportHunterModel>
      
      <div className="title-box">
        <h2 className="h2">Support the best Trias Hunter</h2>
      </div>
      <ul className="hunter-list">
        {hunterLists.map((hunter, index)=> {
          return <HunterItem key={index}>
                    <h3 className="h3">00{index+1}</h3>
                    <div className="userinfo">
                      {/* <div className="avatar">
                        <img src={hunter.avatar} alt="" />
                      </div> */}
                      <h3 className="h3">{hunter.name}</h3>
                    </div>
                    <div className="desc">
                      {hunter.desc}
                    </div>
                    <div className="btn-box">
                      <span className="votes">votes: {hunter.votes ?? ''}</span>
                      <a href={hunter.docxUrl} target="_blank" onClick={(e)=>{
                        if(!hunter.docxUrl) e.preventDefault();
                      }} rel="noreferrer"><BaseBtn heigth="52px">View</BaseBtn></a>
                      <BaseBtn heigth="52px" onClick={()=>{ToShowSupportHunterModel(hunter)}} 
                        disabled
                        style={{cursor: 'not-allowed'}}
                      >Support</BaseBtn>
                    </div>
                  </HunterItem>
        })}
      </ul>
    </HuntersStyle>
  )
}